import type { Frame, MeshBuilder, VertexStyle } from '../../../mesh/meshBuilder';
import { boxSolid, planPoint } from '../../solids';
import type { Rect } from './roofs';

const CLOSED = { top: true, bottom: true } as const;

/** A moulded band round a block: `height` tall from y, standing `outset` proud of its walls. */
export interface Band {
  readonly y: number;
  readonly height: number;
  readonly outset: number;
}

function box(builder: MeshBuilder, style: VertexStyle, frame: Frame, r: Rect, y0: number, y1: number): void {
  boxSolid(builder, style, frame, planPoint(r.u0, y0, r.v1), planPoint(r.u1, y1, r.v0), CLOSED);
}

/** One closed box round the whole block: its middle stays inside the walls and only the rim shows. */
export function stringCourse(builder: MeshBuilder, style: VertexStyle, frame: Frame, r: Rect, band: Band): void {
  const o = band.outset;
  box(builder, style, frame, { u0: r.u0 - o, u1: r.u1 + o, v0: r.v0 - o, v1: r.v1 + o }, band.y, band.y + band.height);
}

/** A parapet on the edge of a flat top, `thickness` deep from its outer face. */
export function parapet(
  builder: MeshBuilder,
  style: VertexStyle,
  frame: Frame,
  r: Rect,
  band: Band & { readonly thickness: number }
): void {
  const o = band.outset;
  const t = band.thickness - o;
  const outer = { u0: r.u0 - o, u1: r.u1 + o, v0: r.v0 - o, v1: r.v1 + o };
  const y1 = band.y + band.height;
  box(builder, style, frame, { ...outer, v1: r.v0 + t }, band.y, y1);
  box(builder, style, frame, { ...outer, v0: r.v1 - t }, band.y, y1);
  box(builder, style, frame, { ...outer, u1: r.u0 + t, v0: r.v0 + t, v1: r.v1 - t }, band.y, y1);
  box(builder, style, frame, { ...outer, u0: r.u1 - t, v0: r.v0 + t, v1: r.v1 - t }, band.y, y1);
}
